import { TippyV2 } from "@circle-react-shared/TippyV2";
import "./styles.scss";

interface ToolbarTooltipProps {
  children: React.ReactNode;
  content?: string;
  disabled?: boolean;
}

export const ToolbarTooltip = ({
  children,
  content,
  disabled,
}: ToolbarTooltipProps) => (
  <TippyV2
    theme="live-toolbar-tooltip"
    content={content}
    enabled={Boolean(content) && !disabled}
    arrow={false}
    className="inline-block"
  >
    {children}
  </TippyV2>
);
